<template>
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="50%">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="80px"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="租户类型" prop="tenantType">
            <el-select v-model="formData.tenantType" placeholder="请选择租户类型" style="width: 100%">
              <el-option label="内部租户（免购买）" :value="1" />
              <el-option label="外部租户（需购买）" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人" prop="contactName">
            <el-input v-model="formData.contactName" placeholder="请输入联系人" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="租户名" prop="name">
        <el-input v-model="formData.name" placeholder="请输入租户名" />
      </el-form-item>
      <el-form-item label="联系手机" prop="contactMobile">
        <el-input v-model="formData.contactMobile" placeholder="请输入联系手机" />
      </el-form-item>
      <el-form-item v-if="formData.id === undefined" label="邀请码" prop="inviteCode">
        <el-input
          v-model="formData.inviteCode"
          placeholder="可选；有分销拉取时填写，与联系手机一起匹配成立"
          maxlength="32"
        />
        <div v-if="distPrecheckHint" class="dist-precheck-hint" :class="distPrecheckMatched ? 'ok' : 'warn'">
          {{ distPrecheckHint }}
        </div>
      </el-form-item>
      <el-form-item v-if="formData.id === undefined" label="用户名称" prop="username">
        <el-input v-model="formData.username" placeholder="请输入用户名称" />
      </el-form-item>
      <el-form-item v-if="formData.id === undefined" label="用户密码" prop="password">
        <el-input
          v-model="formData.password"
          placeholder="请输入用户密码"
          show-password
          type="password"
        />
      </el-form-item>
      <el-form-item label="账号额度" prop="accountCount">
        <el-input-number
          v-model="formData.accountCount"
          :min="0"
          controls-position="right"
          placeholder="请输入账号额度"
        />
      </el-form-item>
      <el-form-item
        v-if="formData.tenantType === 2"
        label="OSS配额"
        prop="ossQuotaGb"
      >
        <el-input-number
          v-model="formData.ossQuotaGb"
          :min="0"
          :precision="2"
          :step="1"
          controls-position="right"
          placeholder="留空=用平台默认赠送"
        />
        <span class="ml-8px text-gray-400">GB（0=零盘须买套餐；新建留空读配置）</span>
      </el-form-item>
      <el-form-item v-if="formData.tenantType === 2 && formType === 'update'" label="OSS已用">
        <span>{{ formatOssUsed }}</span>
      </el-form-item>
      <el-alert
        v-if="formData.tenantType === 1"
        class="mb-12px"
        type="info"
        :closable="false"
        title="内部租户 OSS 不限量，不计费"
      />
      <el-form-item label="过期时间" prop="expireTime">
        <el-date-picker
          v-model="formData.expireTime"
          clearable
          placeholder="请选择过期时间"
          type="date"
          value-format="x"
        />
      </el-form-item>
      <el-form-item label="租户状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio
            v-for="dict in getIntDictOptions(DICT_TYPE.COMMON_STATUS)"
            :key="dict.value"
            :value="dict.value"
          >
            {{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-divider content-position="left">页面水印配置</el-divider>
      <el-form-item label="开启水印" prop="watermarkEnabled">
        <el-switch
          v-model="formData.watermarkEnabled"
          active-color="#13ce66"
          inactive-color="#dcdfe6"
          style="--el-switch-off-color: #dcdfe6"
        />
      </el-form-item>
      <el-form-item v-if="formData.watermarkEnabled" label="水印文字" prop="watermarkText">
        <el-input
          v-model="formData.watermarkText"
          placeholder="请输入水印文字"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
      <template v-if="formData.watermarkEnabled">
        <el-form-item label="字体大小" prop="watermarkFontSize">
          <el-input-number v-model="formData.watermarkFontSize" :min="12" :max="72" /><span
            class="ml-8px"
            >px</span
          >
        </el-form-item>
        <el-form-item label="水印颜色" prop="watermarkColor">
          <el-color-picker v-model="formData.watermarkColor" />
          <el-input
            v-model="formData.watermarkColor"
            class="ml-12px w-140px"
            placeholder="#000000"
          />
        </el-form-item>
        <el-form-item label="水印间距" prop="watermarkGap">
          <el-slider
            v-model="formData.watermarkGap"
            class="w-300px"
            :min="20"
            :max="500"
            show-input
          />
        </el-form-item>
        <el-form-item label="透明度" prop="watermarkOpacity">
          <el-slider
            v-model="formData.watermarkOpacity"
            class="w-300px"
            :min="1"
            :max="100"
            show-input
            show-stops
          /><span class="ml-8px">%</span>
        </el-form-item>
      </template>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>
<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import * as TenantApi from '@/api/system/tenant'
import * as SaasDistApi from '@/api/system/saas-dist'
import { bytesToGb, formatBytes, gbToBytes } from '@/api/system/ossCapacity'
import { CommonStatusEnum } from '@/utils/constants'
import { ElMessageBox } from 'element-plus'

defineOptions({ name: 'SystemTenantForm' })

const { t } = useI18n() // 国际化
const message = useMessage() // 消息弹窗
const dialogVisible = ref(false) // 弹窗的是否展示
const dialogTitle = ref('') // 弹窗的标题
const formLoading = ref(false) // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
const formType = ref('') // 表单的类型：create - 新增；update - 修改
const formData = ref({
  id: undefined as number | undefined,
  name: undefined as string | undefined,
  contactName: undefined as string | undefined,
  contactMobile: undefined as string | undefined,
  inviteCode: undefined as string | undefined,
  tenantType: 2, // 默认外部租户
  accountCount: undefined as number | undefined,
  /** 编辑/展示用 GB；提交时转 bytes。新建留空=undefined → 不传 ossQuota */
  ossQuotaGb: undefined as number | undefined,
  ossUsed: undefined as number | undefined,
  expireTime: undefined,
  status: CommonStatusEnum.ENABLE,
  watermarkEnabled: false,
  watermarkText: '',
  watermarkFontSize: 30,
  watermarkColor: '#000000',
  watermarkGap: 80,
  watermarkOpacity: 15,
  // 新增专属
  username: undefined as string | undefined,
  password: undefined as string | undefined
})

const formatOssUsed = computed(() => formatBytes(formData.value.ossUsed))
const formRules = reactive({
  name: [{ required: true, message: '租户名不能为空', trigger: 'blur' }],
  tenantType: [{ required: true, message: '租户类型不能为空', trigger: 'blur' }],
  contactName: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
  status: [{ required: true, message: '租户状态不能为空', trigger: 'blur' }],
  accountCount: [{ required: true, message: '账号额度不能为空', trigger: 'blur' }],
  expireTime: [{ required: true, message: '过期时间不能为空', trigger: 'blur' }],
  username: [{ required: true, message: '用户名称不能为空', trigger: 'blur' }],
  password: [{ required: true, message: '用户密码不能为空', trigger: 'blur' }],
  watermarkText: [{ required: true, message: '开启水印后文字不能为空', trigger: 'blur' }]
})
const formRef = ref() // 表单 Ref
const distPrecheckHint = ref('')
const distPrecheckMatched = ref(false)

/** 打开弹窗 */
const open = async (type: string, id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  // 修改时，设置数据
  if (id) {
    formLoading.value = true
    try {
      const data = await TenantApi.getTenant(id)
      formData.value = {
        ...formData.value,
        ...data,
        ossQuotaGb: bytesToGb(data.ossQuota),
        ossUsed: data.ossUsed
      }
    } finally {
      formLoading.value = false
    }
  }
}
defineExpose({ open }) // 提供 open 方法，用于打开弹窗

/** 提交表单 */
const emit = defineEmits(['success']) // 定义 success 事件，用于操作成功后的回调
const submitForm = async () => {
  // 校验表单
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return

  // P0-1：新建租户前分销匹配预检
  if (formType.value === 'create') {
    const mobile = (formData.value.contactMobile || '').trim()
    const invite = (formData.value.inviteCode || '').trim()
    try {
      const pre = await SaasDistApi.matchSaasDistPrecheck({
        contactMobile: mobile || undefined,
        inviteCode: invite || undefined
      })
      distPrecheckHint.value = pre.message || ''
      distPrecheckMatched.value = !!pre.matched
      if (pre.matched) {
        await ElMessageBox.confirm(pre.message + '。确认继续创建租户？', '分销归属确认', {
          type: 'success',
          confirmButtonText: '继续创建',
          cancelButtonText: '返回修改'
        })
      } else {
        await ElMessageBox.confirm(
          (pre.message || '开户后将无分销归属') + '。确认继续创建租户？',
          '无分销归属警告',
          {
            type: 'warning',
            confirmButtonText: '仍要创建',
            cancelButtonText: '返回修改'
          }
        )
      }
    } catch (e: any) {
      // 取消确认框，或预检失败：均中止提交
      if (e === 'cancel' || e === 'close') return
      return
    }
  }

  // 提交请求
  formLoading.value = true
  try {
    const data = { ...(formData.value as unknown as TenantApi.TenantVO) }
    if (formData.value.tenantType === 1) {
      data.ossQuota = undefined as any
    } else if (formData.value.ossQuotaGb === undefined || formData.value.ossQuotaGb === null) {
      // 新建留空：不传，后端读配置；编辑留空不应清空——编辑时要求有值
      if (formType.value === 'create') {
        delete (data as any).ossQuota
      } else {
        data.ossQuota = 0
      }
    } else {
      data.ossQuota = gbToBytes(Number(formData.value.ossQuotaGb))
    }
    delete (data as any).ossQuotaGb
    delete (data as any).ossUsed
    if (formType.value === 'create') {
      await TenantApi.createTenant(data)
      message.success(t('common.createSuccess'))
    } else {
      await TenantApi.updateTenant(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    // 发送操作成功的事件
    emit('success')
  } finally {
    formLoading.value = false
  }
}

/** 重置表单 */
const resetForm = () => {
  formData.value = {
    id: undefined,
    name: undefined,
    contactName: undefined,
    contactMobile: undefined,
    inviteCode: undefined,
    tenantType: 2,
    accountCount: undefined,
    ossQuotaGb: undefined,
    ossUsed: undefined,
    expireTime: undefined,
    status: CommonStatusEnum.ENABLE,
    watermarkEnabled: false,
    watermarkText: '',
    watermarkFontSize: 30,
    watermarkColor: '#000000',
    watermarkGap: 80,
    watermarkOpacity: 15,
    username: undefined,
    password: undefined
  }
  distPrecheckHint.value = ''
  distPrecheckMatched.value = false
  formRef.value?.resetFields()
}
</script>

<style lang="scss" scoped>
.el-switch.is-checked .el-switch__core {
  border-color: #13ce66;
  background-color: #13ce66;
}
.el-switch .el-switch__core {
  border-color: #909399;
  background-color: #909399;
}
.dist-precheck-hint {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.4;
  &.ok {
    color: var(--el-color-success);
  }
  &.warn {
    color: var(--el-color-warning);
  }
}
</style>
